import { trimEnd, trimStart } from 'lodash-es'

export function toAbsUrl(path?: string) {
  if (!path) {
    return undefined
  } else if (/^https?:\/\//i.test(path)) {
    return path
  } else if (typeof window === 'undefined') {
    return undefined
  }

  const base = new URL(import.meta.env.BASE_URL || '/', window.location.origin)
  return new URL(path.replace(/^\//, ''), base).href
}

export function joinURL(base: string, path: string) {
  return trimEnd(base, '/') + '/' + trimStart(path, '/')
}
